import type { Rag } from '@/features/relatorio/types'

/** Caixa/posição positivo é verde; negativo acende o alerta vermelho. */
export function ragDeSaldo(valor: number): Rag {
  return valor >= 0 ? 'verde' : 'vermelho'
}

/** Sem inadimplência é verde; havendo qualquer valor vencido, amarelo (atenção). */
export function ragDeInadimplencia(valor: number): Rag {
  return valor > 0 ? 'amarelo' : 'verde'
}
